import React from 'react'
import { Outlet } from 'react-router'
import Footer from './Footer/Footer'
import NavBar from './NavBar/NavBar'

const LandingPageLayout = () => {
  return (
    <div>
      <NavBar/>
        <Outlet />
      <Footer />
    </div>
  )
}

export default LandingPageLayout

